import { render, staticRenderFns } from "./RcclNewsIndex.vue?vue&type=template&id=3969d636&scoped=true"
import script from "./RcclNewsIndex.vue?vue&type=script&lang=js"
export * from "./RcclNewsIndex.vue?vue&type=script&lang=js"
import style0 from "./RcclNewsIndex.vue?vue&type=style&index=0&id=3969d636&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3969d636",
  null
  
)

export default component.exports